import React, { useState,useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import _ from "lodash";

import { PersonalChart } from "components/PersonalChart";
import { Notes } from "components/Notes";
import { Arrows } from "components/programCardComponents/Arrows";
import { RemoveFavorite } from "components/RemoveFavorite";
import { SearchResultsBody } from "components/programCardComponents/SearchResultsBody";
import { OpenUntilAndSignUp } from "components/programCardComponents/OpenUntilAndSignUp";
import { GlobalState } from "contexts/GlobalState";
import "./style.scss";

export const FavoriteProgramGrid = ({
  favoriteData,
  getAllFavorites,
  item,
  labels,
  notes,
  searchResultsLabels,
  trackId
}) => {
  const [globalUser, setGlobalUser] = GlobalState("user");
  const [descOpen, setDescOpen] = useState(Utils.isMobile() ? false : true);
  const allLabels = { ...labels, ...searchResultsLabels };

  const [semester, setSemester] = useState({
    // number: 0,
    // title: item?.field_semester?.[0]?.title,
    // field_this_year_receipt_threshol: item?.field_semester?.[0]?.field_this_year_receipt_threshol,
    // field_this_year_rejection_thresh: item?.field_semester?.[0]?.field_this_year_rejection_thresh,
    // field_end_registration: item?.field_semester?.[0]?.field_end_registration,
  });

  useEffect(() => {
    item?.field_semester && item?.field_semester.forEach((semesterObg, i) => {
      if (semesterObg) {
        setSemester((prevState) => ({ ...prevState, number: i }));
        setSemester((prevState) => ({ ...prevState, title: semesterObg?.title }));
        setSemester((prevState) => ({ ...prevState, field_this_year_receipt_threshol: semesterObg?.field_this_year_receipt_threshol }));
        setSemester((prevState) => ({ ...prevState, field_this_year_rejection_thresh: semesterObg?.field_this_year_rejection_thresh }));
        setSemester((prevState) => ({ ...prevState, field_end_registration: semesterObg?.field_end_registration }));

      }
    })
  }, [item]);
  return (
    <div className="favorite-program shape">
      <Row className="grey-background-half">
        <Col xs={12} md={12} className="details details-2">
          <Row className="arrows-and-remove-button-row" xs={2} sm={2} md={2}>
            <Arrows item={item} getAllFavorites={getAllFavorites} md={6} favoriteData={favoriteData} labels={labels}/>
            <RemoveFavorite getAllFavorites={getAllFavorites} labels={searchResultsLabels} item={item} />
          </Row>
          <Row xs={2} sm={2} md={2}>
            <SearchResultsBody
              parentWidget="FavoriteProgramGrid"
              md={12} item={item}
              labels={allLabels}
              descOpen={descOpen}
              setDescOpen={setDescOpen} />
          </Row>
        </Col>
        {descOpen && (
          <Col sm={12} md={12} className="details">
            <Col sm={12} md={12} className="open-until-and-sign-up-col">
              <OpenUntilAndSignUp
                labels={searchResultsLabels}
                semester={semester}
                item={item}
                trackId={trackId}
              />
            </Col>
          </Col>
        )}
      </Row>
      {descOpen && (
        <Row className="white-background-half">
          <PersonalChart
            labels={searchResultsLabels}
            rejectionScore={semester.field_this_year_rejection_thresh}
            acceptanceScore={semester.field_this_year_receipt_threshol}
            width={Utils.isMobile() ? "45em" : "23.5em"}
            height={Utils.isMobile() ? "25em" : "19.5em"}
            info={true}
            border={"show"}
            stats_sentence={true}
          />
          <Notes item={item} defaultNotes={notes ?? ""} labels={labels} />
        </Row>
      )}
    </div>
  );
};
